<template>
	<div
		v-if="!isLoading"
		class="columns is-multiline is-justify-content-center mt-4 p-4"
		data-testid="ws-empty-state"
	>
		<div class="is-flex-column has-text-centered is-align-items-center">
			<template v-if="isIconCover">
				<div class="icon-cover">
					<slot name="icon" />
				</div>
			</template>
			<template v-else>
				<slot name="icon" />
			</template>
			<div class="is-size-5 has-text-weight-semibold mt-4 mb-2">
				<slot name="header" />
			</div>
			<div class="is-size-6 px-30 mb-2" style="max-width: 800px">
				<slot name="description" />
			</div>
			<div
				v-if="hasSlotButton"
				class="column is-flex is-align-items-center"
			>
				<slot name="button" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed, useSlots } from "vue";

defineProps({
	isIconCover: {
		type: Boolean,
		default: false
	},
	isLoading: {
		type: Boolean,
		default: false
	}
});

const slots = useSlots();

const hasSlotButton = computed(() => slots.button);
</script>

<style lang="scss" scoped>
.icon-cover {
	width: 100%;
	& :deep(svg) {
		min-height: 200px;
		max-height: 40dvh;
	}
}
</style>
